import { useDispatch, useSelector } from "react-redux";
import LoadingScreen from "../core/components/LoadingScreen";
import { setAttributeRelatorio, triggerLoadRelatorio } from "./RelatorioSlice";
import * as React from 'react';
import { Box, Grid, Sheet, Stack, Table, Typography, Checkbox } from "@mui/joy";
import { stringify } from "uuid";
import { useState } from 'react';
// import {
//     Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Paper,
//     TableSortLabel
// } from '@mui/joy';

function RelatorioDashboard() {

    var dispatch = useDispatch();
    var loading = useSelector((state) => state.relatorio.loading)
    var respostas = useSelector((state) => state.relatorio.respostas)
    var exibeTestes = useSelector((state) => state.relatorio.exibeTestes)

    React.useEffect(() => {
        dispatch(triggerLoadRelatorio())
    }, []);

    if (loading) {
        return <LoadingScreen />
    }

    var toggleExibirTestes = () => {
        dispatch(setAttributeRelatorio({
            campo: "exibeTestes",
            value: !exibeTestes
        }))
    }

    return <><Grid xs={12}>

        <h3>Relatório da pesquisa de vendas perdidas - pesquisa.alkent.com.br</h3>
    </Grid><Grid>

            <Checkbox
                checked={exibeTestes === false}
                onClick={toggleExibirTestes} label="Esconder testes" />
        </Grid>
        <Grid>
            <DataTable data={respostas} exibeTestes={exibeTestes} />
        </Grid></>;
    // return <Grid>
    //     <Stack>
    //         {respostas.map(e => {
    //             return <Box component={"pre"}>
    //                 {JSON.stringify(e)}
    //             </Box>
    //         })}
    //     </Stack>
    // </Grid>
}

export default RelatorioDashboard;

const createMarkup = (html) => {
    return { __html: html };
};

// Função para ordenar os dados
const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
};

const getComparator = (order, orderBy) => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};

const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

const DataTable = ({ data, exibeTestes }) => {
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('dataOrdenavel');

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        // console.log(event);
    };


    const headCells = [
        { id: 'dataOrdenavel', label: 'Data', width: "10%" },
        { id: 'local', label: 'Local', width: "5%" },
        { id: 'canal', label: 'Canal', width: "5%" },
        { id: 'atendente', label: 'Atendente', width: "8%" },
        { id: 'cliente', label: 'Cliente', width: "15%" },
        { id: 'razao', label: 'Razão', width: "20%" },
        { id: 'observacao', label: 'Complemento' },
    ];

    return (
        // <TableContainer component={Paper}>

        <Table stripe={"odd"} hoverRow>
            <thead>
                <tr>
                    {headCells.map((headCell) => (
                        <th key={headCell.id}
                            width={headCell.width}
                            onClick={() => handleRequestSort(headCell.id)}  >
                            {headCell.label}
                            {orderBy === headCell.id || (orderBy === "data" && headCell.id === "dataOrdenavel") ? (order === 'asc' ? ' ▲' : ' ▼') : ''}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {stableSort(data, getComparator(order, orderBy))
                    .filter(e => {
                        if (!exibeTestes) {
                            if (!e.nome.includes("João Victor Bortolani Assy")) {
                                return e;
                            }
                        } else {
                            return e;
                        }

                    })
                    .map((row, index) => {

                        return <tr key={index}>
                            <td>{row.data}</td>
                            <td>{row.local}</td>
                            <td>{row.canal}</td>
                            <td>{row.atendente}</td>
                            <td dangerouslySetInnerHTML={createMarkup(row.nome)}></td>
                            <td>{row.razao}</td>
                            <td dangerouslySetInnerHTML={createMarkup(row.observacao)}></td>
                        </tr>
                    }
                    )}
            </tbody>
        </Table>
        // </TableContainer >
    );
};

// DataTable.propTypes = {
//   data: PropTypes.array.isRequired,
// };

